angular.module("digitalLeasing.module")
.component("bancaPrestoLeasing",{
    templateUrl:"ng/components/digitalLeasing/bancaPrestoLeasing/bancaPrestoLeasing.view.html",
    bindings:{
        model:'=',
        validatePage:'&',
        snapshot:'<'
    },
    controller: BancaPrestoLeasing,
    controllerAs: "bankPreLeasCtrl"
})

function BancaPrestoLeasing (
    $simulationService
){
    var self = this;

    self.$onInit = function(){
        self.visualModuleNplInfo();
    }


    self.visualModuleNplInfo = function(){
        $simulationService.moduloNplInfo(self.model.leasingData.id, self.model.leasingData.preventivo.deliberaBanca.moduloInfoBanca.inAllestimento)
        .then(function(response){
            self.responseModuloNplInfo= response;
            self.model.leasingData.preventivo.deliberaBanca.moduloInfoBanca.gestioneOrdineFornitoreCuraBanca= response.gestioneOrdineFornitoreCuraBanca;
            self.model.leasingData.preventivo.deliberaBanca.moduloInfoBanca.gestionePagamentoFornitoreCuraBanca= response.gestionePagamentoFornitoreCuraBanca;
            self.model.leasingData.preventivo.deliberaBanca.moduloInfoBanca.inAllestimento= response.inAllestimento;
            Object.assign(self.model,{responseModuloNplInfo: self.responseModuloNplInfo});
        })
    }

    self.validateInfoBanca= function(value){
        self.validateInfoBancaComponent= value;
        checkIfPageIsValid();
    }

    self.validateBeneInLeasing = function(value){
        self.validateBeneInLeasingVariable= value;
        checkIfPageIsValid();
    }

    var checkIfPageIsValid= function(){
        var test= self.validateInfoBancaComponent;

        if(self.model.responseModuloNplInfo && self.model.responseModuloNplInfo.showTipologiaBenePagamento){
            test= test && self.validateBeneInLeasingVariable;
        }

        self.validatePage({value: test});


    }


}